module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAOBJREFUOE+t0s0KAVEUB/D/GUU2d8pihtJVwsJD2Vp4BEXKyoInsLWwsOcJvABbhtWMlAYpH/doylc+h9zlPedX5/7vIUfIBoAMgxe4P0xLqEDZXI/s+xLZIlFXipux1WTwAN9c0EyXtQNrnag77r/qY2SDhOH2tu4LOiJRYCjTdKelM/YFbV0midEGU9dYWkUP+4Je4xTxcEhoXYB6hmtVH+A8khKH/S53Gokv72JsAMUgqhC48T/4KtmPoz6DjoinAa0Fpt5X4cx0mWdF8ox8p8oAEXANyvuOn1fu1yU/Ap2wqx0kbsF/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/login/exit.png
// module id = paI2
// module chunks = 202